import React from 'react';
import { Search, X } from 'lucide-react';
import './Common.css';

function SearchBar({ value, onChange, placeholder = 'Rechercher...', onClear }) {
  const handleClear = () => {
    onChange('');
    if (onClear) onClear();
  };

  return (
    <div className="search-bar">
      <div className="search-input-wrapper">
        <Search className="search-icon" size={20} />
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="search-input"
        />
        {value && (
          <button
            type="button"
            onClick={handleClear}
            className="search-clear-btn"
            aria-label="Effacer la recherche"
          >
            <X size={18} />
          </button>
        )}
      </div>
    </div>
  );
}

export default SearchBar;
